"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToRoles = exports.deleteRoleRealTime = exports.editRoleRealTime = exports.addRoleRealTime = exports.editRole = exports.deleteRole = exports.addRole = exports.fetchRoleById = exports.fetchRolesByWarehouseId = exports.fetchRolesInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    status: "idle",
    error: null,
    globalData: {},
    loaded: false,
};
// Fetch all items
exports.fetchRolesInBatches = (0, toolkit_1.createAsyncThunk)("warehouseRoles/fetchRolesInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("warehouseRoles").select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
exports.fetchRolesByWarehouseId = (0, toolkit_1.createAsyncThunk)("warehouseRoles/fetchRolesByWarehouseId", function (warehouseId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseRoles")
                        .select("*")
                        .eq("warehouseId", warehouseId)];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch role by ID
exports.fetchRoleById = (0, toolkit_1.createAsyncThunk)("warehouseRoles/fetchRoleById", function (roleId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseRoles")
                        .select("*")
                        .eq("id", roleId)
                        .single()];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Add a new role
exports.addRole = (0, toolkit_1.createAsyncThunk)("warehouseRoles/addRole", function (newRole, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseRoles")
                    .insert(newRole)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a role
exports.deleteRole = (0, toolkit_1.createAsyncThunk)("warehouseRoles/deleteRole", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseRoles")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a role
exports.editRole = (0, toolkit_1.createAsyncThunk)("warehouseRoles/editRole", function (updatedRole, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseRoles")
                    .update(updatedRole)
                    .eq("id", updatedRole.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addRoleRealTime = function (newRole) { return ({
    type: "warehouseRoles/addRoleRealTime",
    payload: newRole,
}); };
exports.addRoleRealTime = addRoleRealTime;
var editRoleRealTime = function (updatedRole) { return ({
    type: "warehouseRoles/editRoleRealTime",
    payload: updatedRole,
}); };
exports.editRoleRealTime = editRoleRealTime;
var deleteRoleRealTime = function (id) { return ({
    type: "warehouseRoles/deleteRoleRealTime",
    payload: id,
}); };
exports.deleteRoleRealTime = deleteRoleRealTime;
// Slice definition
var warehouseRolesSlice = (0, toolkit_1.createSlice)({
    name: "warehouseRoles",
    initialState: initialState,
    reducers: {
        addRoleRealTime: function (state, action) {
            var exists = state.data.some(function (role) { return role.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editRoleRealTime: function (state, action) {
            var index = state.data.findIndex(function (role) { return role.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteRoleRealTime: function (state, action) {
            state.data = state.data.filter(function (role) { return role.id !== action.payload; });
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // Fetch all roles
            .addCase(exports.fetchRolesInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchRolesInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            action.payload.forEach(function (role) {
                var _a;
                state.globalData[(_a = role.id) !== null && _a !== void 0 ? _a : ""] = role;
            });
            state.status = "succeeded";
        })
            .addCase(exports.fetchRolesInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch roles.";
        })
            // Fetch all roles
            .addCase(exports.fetchRolesByWarehouseId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchRolesByWarehouseId.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchRolesByWarehouseId.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch roles.";
        })
            // Fetch role by ID
            .addCase(exports.fetchRoleById.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchRoleById.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = [action.payload];
            state.status = "succeeded";
        })
            .addCase(exports.fetchRoleById.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch role.";
        })
            // Handle addRole
            .addCase(exports.addRole.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addRole.rejected, function (state, action) {
            state.error = action.payload || "Failed to add role.";
        })
            // Handle deleteRole
            .addCase(exports.deleteRole.fulfilled, function (state, action) {
            state.data = state.data.filter(function (role) { return role.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteRole.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete role.";
        })
            // Handle editRole
            .addCase(exports.editRole.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (role) { return role.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editRole.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit role.";
        });
    },
});
// Real-time subscription function
var subscribeToRoles = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:warehouseRoles")
        .on("postgres_changes", { event: "*", schema: "public", table: "warehouseRoles" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addRoleRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editRoleRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteRoleRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToRoles = subscribeToRoles;
exports.default = warehouseRolesSlice.reducer;
